import { v4 as uuidv4 } from "uuid";

//navbar sections data
export const sectionsData = [
  {
    id: uuidv4(),
    label: "World",
    slug: "world",
  },
  {
    id: uuidv4(),
    label: "U.S.",
    slug: "us",
  },
  {
    id: uuidv4(),
    label: "Politics",
    slug: "politics",
  },
  {
    id: uuidv4(),
    label: "Local",
    slug: "local",
  },
  {
    id: uuidv4(),
    label: "Business",
    slug: "business",
  },
  {
    id: uuidv4(),
    label: "Opinion",
    slug: "opinion",
  },
  {
    id: uuidv4(),
    label: "Tech",
    slug: "technology",
  },
  {
    id: uuidv4(),
    label: "Science",
    slug: "science",
  },
  {
    id: uuidv4(),
    label: "Health",
    slug: "health",
  },
  {
    id: uuidv4(),
    label: "Sports",
    slug: "sports",
  },
  {
    id: uuidv4(),
    label: "Arts",
    slug: "arts",
  },
  {
    id: uuidv4(),
    label: "Books",
    slug: "books",
  },
  {
    id: uuidv4(),
    label: "Style",
    slug: "style",
  },
  {
    id: uuidv4(),
    label: "Food",
    slug: "food",
  },
  {
    id: uuidv4(),
    label: "Travel",
    slug: "travel",
  },
  {
    id: uuidv4(),
    label: "Magazine",
    slug: "magazine",
  },
  {
    id: uuidv4(),
    label: "The Agentic",
    slug: "the-agentic",
  },
  {
    id: uuidv4(),
    label: "Real Estate",
    slug: "realestate",
  },
];
